export default {
  addCareerAction (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("addCareer", payload)
      resolve()
    })
  }
}
